import { render } from "./FileTable.vue?vue&type=template&id=64191a83&scoped=true"
import script from "./FileTable.vue?vue&type=script&lang=js"
export * from "./FileTable.vue?vue&type=script&lang=js"

import "./FileTable.vue?vue&type=style&index=0&id=64191a83&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64191a83"

export default script